export enum VuPaymentType {
  Cash = 'cash',
  CashBillsOnly = 'cashBillsOnly',
  Card = 'card',
}
